import { request } from './core'
import { buildQueryString } from '../../utils/apiQueryBuilder'
import type { Simulation } from './types'

export const simulationsApi = {
  list: (params?: {
    agent_id?: string
    environment_id?: string
    search?: string
    page?: number
    page_size?: number
    signal?: AbortSignal
  }) => {
    const { signal, ...queryParams } = params || {}
    const query = buildQueryString(queryParams)
    return request<{ items: Simulation[]; total: number }>(`/simulations${query}`, { signal })
  },

  stop: (simulationId: string) =>
    request<{ message: string; simulation_id: string; status: string }>(
      `/simulations/${simulationId}/stop`,
      {
        method: 'POST',
      }
    ),

  getLogs: (simulationId: string) =>
    request<{ simulation_id: string; logs: unknown; status: string }>(
      `/simulations/${simulationId}/logs`
    ),
}
